import OtherFinancialsList from './components/List'
const OtherFinancials: React.FC = () => {
    return <OtherFinancialsList />
}

export default OtherFinancials
